import componentsSidebar from "./data";
import {BehaviorSubject} from "rxjs";

export function getSidebarMenus() {
	let node = {};
	let menus = new BehaviorSubject(localStorage.getItem('menus')).getValue();
	if (menus) {
		menus = JSON.parse(menus);
		menus.map((menu, _) => {
			let item = {
				...menu,
				path: '/main'+ menu.url,
				// name: menu.name,
				// icon: menu.icon,
				// app: menu.app,
				child: []
			};
			if (menu.url in componentsSidebar) {
				item.component = componentsSidebar[menu.url].comp;
			}
			if (menu.parent === "" || menu.parent == null) {
				node[menu.id] = item;
			} else {
				node[menu.parent.id].collapse = true;
				node[menu.parent.id].state = node[menu.parent.id].name;
				node[menu.parent.id].child.push(item);
			}
			return null;
		});
	}
	return Object.values(node);
}
